// ConsentBanner — GDPR cookie/consent banner shown ONLY to EEA + UK visitors
// (decided server-side by geo; see consent.js + backend/market_profile). Non-EEA
// visitors (India, US, rest) never see it and are never gated. Analytics/pixels
// stay OFF for these visitors until they accept — honest, equal-weight choice
// (no pre-ticked boxes, Decline is as easy as Accept).
import { useEffect, useState } from "react";
import { subscribeConsent, needsBanner, acceptConsent, declineConsent } from "@/utils/consent";

export default function ConsentBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => subscribeConsent(() => setShow(needsBanner())), []);

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-label="Cookie consent"
      data-testid="consent-banner"
      style={{
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 9999,
        background: "#0A1128", color: "#fff",
        borderTop: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 -8px 30px rgba(0,0,0,0.25)",
        padding: "16px 20px",
      }}
    >
      <div
        style={{
          maxWidth: 1100, margin: "0 auto", display: "flex", gap: 16,
          alignItems: "center", justifyContent: "space-between", flexWrap: "wrap",
        }}
      >
        <p style={{ fontSize: 13.5, lineHeight: 1.5, margin: 0, color: "rgba(255,255,255,0.82)", flex: "1 1 340px" }}>
          We use cookies for analytics and to measure our ads. You can accept
          these, or decline and we&rsquo;ll only use what&rsquo;s strictly
          necessary to run the site. See our{" "}
          <a href="/privacy" style={{ color: "#9AB0FF", textDecoration: "underline" }}>Privacy Policy</a>.
        </p>
        <div style={{ display: "flex", gap: 10, flex: "0 0 auto" }}>
          <button
            type="button"
            data-testid="consent-decline"
            onClick={() => declineConsent()}
            style={{
              padding: "9px 18px", borderRadius: 8, cursor: "pointer",
              background: "transparent", color: "#fff",
              border: "1px solid rgba(255,255,255,0.35)", fontWeight: 600, fontSize: 13.5,
            }}
          >
            Decline
          </button>
          <button
            type="button"
            data-testid="consent-accept"
            onClick={() => acceptConsent()}
            style={{
              padding: "9px 18px", borderRadius: 8, cursor: "pointer",
              background: "#5B3DF5", color: "#fff", border: "1px solid #5B3DF5",
              fontWeight: 700, fontSize: 13.5,
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
